/**
 * Transcript search form and download
 */

import { h } from "preact";
import { useContext, useState } from "preact/hooks";
import SearchContext from "../../features/utils/SearchContext";
import { Input, Button } from "../../shared/components";

// This is not a good import from the global module again; refactor this.
import globalCss from "../../global.module.scss";
import css from "./SearchForm.module.scss";
import { useRecordedURL } from "../../helpers/routes";
import SettingsContext from "../../SettingsContext";

interface SearchFormProps {
  id: string;
  enabled: boolean;
  selectedLang: string;
}

const SearchForm = (props: SearchFormProps) => {
  const { id, enabled, selectedLang } = props;

  const { setSearchString } = useContext(SearchContext);
  const [inputValue, setInputValue] = useState<string>("");

  const { settings } = useContext(SettingsContext);

  const settingsUrl = useRecordedURL("/transcript", {
    format: "tx-pdf",
    preferred_languages: [selectedLang],
  });

  const handleSubmit = (e: Event) => {
    e.preventDefault();
  };

  return (
    <div
      class={
        enabled
          ? `
      ${css.wrapper}
      ${globalCss.fullWidth}
      ${globalCss.flex}
      ${globalCss.jcEnd}
    `
          : `${css.wrapper} ${css.isHidden}`
      }
    >
      <form
        id={id}
        class={
          enabled
            ? `${globalCss.flex} ${globalCss.posRelative} ${css.form}`
            : `${css.form} ${css.isHidden}`
        }
        onSubmit={(e) => {
          handleSubmit(e);
          setSearchString(inputValue);
        }}
      >
        <Input
          formItemStyle={globalCss.fullWidth}
          inputStyle={css.input}
          type="search"
          id="search"
          label="Search transcript"
          labelHidden
          placeholder="Search..."
          onChange={(val) => setInputValue(val)}
        />
        <Button
          className={css.button}
          formId="keyword-search"
          id="search-submit"
          tag="button"
          iconType="search"
          label="Submit Search"
          type="submit"
          labelHidden
          iconStyle={css.icon}
        />
      </form>
      {settings.showDownload && (
        <Button
          className={css.download}
          title="Download Transcript"
          id="download-pdf"
          tag="a"
          iconType="download"
          label="Download PDF"
          labelHidden
          iconStyle={css.icon}
          download
          href={settingsUrl.toString()}
        />
      )}
    </div>
  );
};

export default SearchForm;
